import PropTypes from 'prop-types';

export const ANALYTICS_IDENTIFIER = 'patient-web-application';

export const COOKIES = {
    isNewPatient: {
        name: 'isNewPatient',
        expiration: 1, // in days
    },
};

export const ACTION_TYPES = {
    PAGE_LOAD: '@@PAGE_LOAD',
};

export const BusinessUnit = {
    PATIENT_WEB_APP: 'PatientWebApp',
    MONOLITH_GA_ACTION: 'GA-Event',
};

export const CRAZY_EGG_IDENTIFIERS = {
    ThemedSearch: 'Themed Search',
};

export const EVENT_TYPES = {
    Pageview: 'Pageview',
    Action: 'Action',
    SetCustomDimension: 'Set custom dimension',
    SetContentGroup: 'Set content group',
    FullStoryUrl: 'FullStoryUrl',
    DidHideSyncOverlay: 'DidHideSyncOverlay',
    DidShowSyncOverlay: 'DidShowSyncOverlay',
};

// Medical and Vision insurance types are equal in search,
// however users can have different medical and vision insurance plans.
// This distinction is important for specialty switching in the insurance
// picker and in stored insurance types in cookies or user data.
export const USER_SPECIALTY_INSURANCE_TYPES = {
    DENTAL: 1,
    MEDICAL: 2,
    VISION: 3,
};

export const EventDataSchemaVersion = {
    [BusinessUnit.PATIENT_WEB_APP]: {
        [EVENT_TYPES.Pageview]: '2.1.1',
        [EVENT_TYPES.Action]: '2.1.0',
        [EVENT_TYPES.SetCustomDimension]: '2.1.0',
        [EVENT_TYPES.SetContentGroup]: '2.1.0',
        [EVENT_TYPES.FullStoryUrl]: '2.0.0',
        [EVENT_TYPES.DidHideSyncOverlay]: '2.0.0',
        [EVENT_TYPES.DidShowSyncOverlay]: '2.0.0',
    },
    [BusinessUnit.MONOLITH_WEB]: {
        [EVENT_TYPES.Action]: '1.1.0',
    },
};

export const procedureShape = PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
});

export const specialtyShape = PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
});

export const ProcedureIds = {
    ALLERGY_CONSULTATION: '162',
    ANNUAL_PHYSICAL: '76',
    FLU_SHOT: '134',
    ILLNESS: '75',
    ORTHOPEDIC_CONSULTATION: '104',
    PEDIATRIC_CONSULTATION: '136',
    PLASTIC_SURGERY_CONSULTATION: '349',
    PSYCHIATRY_CONSULTATION: '171',
};

export const SpecialtyIds = {
    ACUPUNCTURE_ORIENTAL_MEDICINE: '365',
    ALLERGIST: '132',
    DIETITIAN: '359',
    EMERGENCY_MEDICINE_PHYSICIAN: '146',
    FACIAL_PLASTIC_SURGEON: '167',
    FAMILY_PHYSICIAN: '102',
    GENETICIST: '148',
    IMMUNOLOGIST: '154',
    INTERNIST: '99',
    MEDICAL_ETHICIST: '354',
    MICROBIOLOGIST: '159',
    NATUROPATHIC: '373',
    OBGYN: '104',
    ORTHOPEDIC_SURGEON: '117',
    PEDIATRIC_DENTIST: '152',
    PEDIATRICIAN: '100',
    PHYSICAL_THERAPIST: '335',
    PHYSICIAN_ASSISTANT: '381',
    PLASTIC_SURGEON: '120',
    PRIMARY_CARE_PHYSICIAN: '153',
    PSYCHIATRIST: '122',
    PSYCHOTHERAPIST: '352',
    PSYCHOLOGIST: '337',
};

export const NonDoctorOrDentistSpecialties = new Set([
    SpecialtyIds.ACUPUNCTURE_ORIENTAL_MEDICINE,
    SpecialtyIds.DIETITIAN,
    SpecialtyIds.GENETICIST,
    SpecialtyIds.MEDICAL_ETHICIST,
    SpecialtyIds.MICROBIOLOGIST,
    SpecialtyIds.NATUROPATHIC,
    SpecialtyIds.PHYSICAL_THERAPIST,
    SpecialtyIds.PHYSICIAN_ASSISTANT,
    SpecialtyIds.PSYCHOLOGIST,
    SpecialtyIds.PSYCHOTHERAPIST,
]);

export const GOVERNMENT_INSURANCE_CARRIERS = {
    Medicare: '356',
    Medicaid: '358',
    Tricare: '377',
};

export const GOVERNMENT_INSURANCE_CARRIERS_SET = new Set(Object.values(GOVERNMENT_INSURANCE_CARRIERS));

export const MARKETING_QUERY_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'promo',
    'custom1',
    'custom2',
    'custom3',
];

export const TIMESGRID_QUERY_PARAMS = [
    'bookingType',
    'referrertype', // Both capitalization variants of this parameter seem to be allowed
    'referrerType',
    'remindersMessageRescheduleId',
    'reschedule',
    'rescheduledRequestId',
    'widget',
];

export const SEARCH_RESULTS_PER_PAGE = 10;

export const ZOCDOC_DIRECTORY_ID = '-1';
export const TEST_DIRECTORY_ID = '-2';
